import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'react-bootstrap'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'


import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { SelectElement } from '../../components/selectElement2'
import TiposAtenHorarios from './TiposAtenHorarios'
import { serverApi } from '../../api'
import { CrearTipoAtencionModal } from './components/CrearTipoAtencionModal'


// const pasarMayusculas= (ev) =>{
//     ev.target.value= ev.target.value.toUpperCase();
// }


const MySwal = withReactContent(Swal);

const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000 }) }

const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({
        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}

export const TiposAtencionPage = () => {

    const { socket } = useContext(SocketContext);
    useHideMenu(false);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'tipoAtencion',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: '',
    });

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();

    const [showModal, setShowModal] = useState(false);
    const [showModalEditar, setShowModalEditar] = useState(false);
    const [tipoEditar, setTipoEditar] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])



    const [isLoading, setIsLoading] = useState(false);
    const [iconos, setIconos] = useState([]);

    const [ubicaciones, setUbicaciones] = useState([]);

    // tabla
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / query.limit);



    const [searchInput, setSearchInput] = useState('');


    const [showHorarios, setShowHorarios] = useState(false);
    const [horarios, setHorarios] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(null);

    /*********************horarios de atencion  */

    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            // console.log(lista);
            setHorarios(lista)

        };

        socket.on('lista-para-horario', handler);

        return () => {
            socket.off('lista-para-horario', handler);
        };

    }, [socket]);


    const handleOpenHorarios = async (uidTipoAtencion, nombre) => {
        setSelectedTipo({ uidTipoAtencion, nombre });

        const codigoEntidad = usuario.codigoEntidad
        const codigoUbicacion = usuario.codigoUbicacion
        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            const resp = await serverApi.post(
                `/tipos-atencion/horarios-tipos-atencion`,
                {
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion
                }
            );

            console.log(resp);

            // if(resp.data.horarios.length === 0) return;
            const hr = resp.data.horarios
            setHorarios(hr);
            setShowHorarios(true);

        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    const handleAddHorario = async (nuevo) => {



        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;
        if (!codigoEntidad || !codigoUbicacion || !uidTipoAtencion) return;

        try {
            const resp = await serverApi.post(
                `/tipos-atencion/horarios-agregar`,
                {
                    ...nuevo,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion
                }
            );

            console.log(resp);


            // const data = await res.json();
            // console.log(data);
            // if(data.ok){
            //     setHorarios([...horarios, nuevo]);
            // }else{
            //     setHorarios([...horarios]);


        } catch (error) {
            console.error("Error al obtener horarios", error);
        }



    };

    const handleEditHorario = async (h) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;

        const ideAgenda = h.ideAgenda;
        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            const resp = await serverApi.put(
                `/tipos-atencion/horarios-editar`,
                {
                    ...h,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    ideAgenda
                }
            );

            console.log(resp);



        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    const handleDeleteHorario = async (ideAgenda) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;

        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            const resp = await serverApi.post(
                `/tipos-atencion/horarios-eliminar`,
                {
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    ideAgenda
                }
            );

            console.log(resp);



        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    /*********************horarios de atencion  */

    useEffect(() => {

        async function fetchData() {

            try {
                const resp = await serverApi.get(`/tipos-atencion/select-iconos`);

                if (resp.data.iconos.length === 0) return;
                const iconos = resp.data.iconos;

                const opciones = iconos.map((item) => ({ value: item.codigoIcono, label: (<> <i className={`${item.codigoIcono} `}></i></>) }))
                setIconos(opciones)
                console.log(opciones);


            } catch (error) {
                console.error("Error al obtener iconos", error);
            }

        }

        fetchData();


    }, [])

    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );



                if (ubicacionUsuario) {
                    console.log(ubicacionUsuario);

                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    //Carga inicial de los tipos de atención


    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        // const codigoUbicacion = usuario.codigoUbicacion

        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
                console.log(query);


                const resp = await serverApi.post(
                    `/tipos-atencion/lista-tiposatencion`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );

                setData(resp.data.listaTiposAtencion || []);
                console.log(resp.data.listaTiposAtencion);

                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario])

    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            console.log(lista);
            setData(lista.listaTiposAtencion);
            setTotal(lista.total || 0);
        };

        socket.on('lista-tiposatencion', handler);

        return () => {
            socket.off('lista-tiposatencion', handler);
        };

    }, [socket]);



    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 800);

        return () => clearTimeout(timeout);

    }, [searchInput]);


    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };


    const reiniciarConsecutivos = async () => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm("Atención", "Esta seguro de reiniciar la numeración?", "warning")
            .then((result) => {
                return (result);
            })
        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/tipos-atencion/reinicia-tiposatencion`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,

                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }


    }

    const inactivaTipoAtencion = async (uidTipoAtencion, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/tipos-atencion/inactiva-tipoatencion`,
                {
                    ...query,
                    uidTipoAtencion,
                    accion,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }


    }


    // const onChangeIconoEdita = async (selected, uidTipoAtencion) => {


    //     const codigoEntidad = usuario.codigoEntidad;
    //     const codigoUbicacion = usuario.codigoUbicacion;
    //     if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');
    //     const campo = "icono";
    //     const valor = selected.value;


    //     try {
    //         setIsLoading(true);

    //         await serverApi.post(
    //             `/tipos-atencion/edita-tipoatencion`,
    //             {
    //                 ...query,
    //                 campo,
    //                 valor,
    //                 uidTipoAtencion,
    //                 codigoEntidad,
    //                 codigoUbicacion,
    //             }
    //         );


    //     } catch (error) {
    //         console.error(error);
    //     } finally {
    //         setIsLoading(false);

    //     }



    // }

    const registraTipoAtencion = async (info) => {

        console.log(info);

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');


        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/tipos-atencion/registra-tipoatencion`,
                {
                    ...info,
                    codigoEntidad,
                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }




        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }



    }


    // const editaTipoAtencion = async ( ev, uidTipoAtencion) =>{

    //     const campo= ev.target.id.split("_")[0];
    //     const valor= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.value;
    //     const valorAnterior= ( ev.target.type === 'checkbox' ) ? ev.target.checked : ev.target.defaultValue;


    //     if ( valor !== valorAnterior || ev.target.type === 'checkbox' ){


    //         const codigoEntidad = usuario.codigoEntidad;
    //         if( !codigoEntidad || codigoEntidad=== null ) return sweet('Atención!', 'Revise la infromación', 'error');

    //         try {
    //             setIsLoading(true);

    //             await serverApi.post(
    //                 `/tipos-atencion/edita-tipoatencion`,
    //                 {
    //                     ...query,
    //                     campo,
    //                     valor,
    //                     uidTipoAtencion,
    //                     codigoEntidad,
    //                 }
    //             );

    //         } catch (error) {
    //             console.error(error);
    //         } finally {
    //             setIsLoading(false);

    //         }



    //     }


    // }

    const handleSelectUbicacion = (selected) => {
        setQuery(prev => ({
            ...prev,
            page: 1,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
    };

    const abrirEditar = (item) => {

        setTipoEditar({
            ...item,
            chkPrioritario: item.indPrioridad === 1,
            chkPermiteTraslado: item.permiteTraslado === 1
        });

        console.log(item);

        setShowModalEditar(true);
    };

    const guardarEdicion = async (datos) => {

        const codigoEntidad = usuario.codigoEntidad;

        console.log(datos);


        try {

            setIsLoading(true);

            await serverApi.post(
                `/tipos-atencion/actualizar-tipoatencion`,
                {
                    ...datos,
                    codigoEntidad,
                    uidTipoAtencion: datos.uidTipoAtencion
                }
            );

            sweet(
                'Correcto',
                'Tipo de atención actualizado',
                'success'
            );

            setShowModalEditar(false);

        } catch (error) {

            console.error(error);

            sweet(
                'Error',
                'No fue posible actualizar',
                'error'
            );

        } finally {

            setIsLoading(false);

        }
    };

    // const currentItems =  data.slice(0, itemsPerPage);


    if (usuario.uidUsuario === null) {
        return (<></>)
    }
    else if (!pantallas.includes("tiposatencion")) {
        return (<NoAcceso />)
    } else {
        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{ minHeight: '100vdh' }}>

                    <div>
                        <div className='row'>
                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-primary m-3'
                                    onClick={() => reiniciarConsecutivos()}
                                >
                                    Reiniciar Consecutivos
                                </button>

                            </div>

                            <div className='col-lg-2 col-12 '>
                                <button
                                    className='btn btn-success m-3'
                                    onClick={() => setShowModal(true)}
                                >
                                    Agregar Tipo Atención
                                </button>



                            </div>
                        </div>


                        <div className='row rounded shadow p-3 '>

                            <div className='col-4 p-3'>
                                <label>Sede/ubicación</label>
                                <SelectElement
                                    options={ubicaciones}
                                    name={`idUbicacion`}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                    onChange={(selected) => handleSelectUbicacion(selected)}
                                    classname="form-control form-control-lg"
                                    isClearable={false}
                                />

                            </div>

                            <div className='col-12'>
                                <div className='float-start col-lg-4 col-12 pagination'>
                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page - 1)}
                                        disabled={query.page === 1}
                                    >
                                        {'<'}
                                    </button>

                                    <button
                                        className='btn btn-sm btn-secondary m-1'
                                        onClick={() => paginate(query.page + 1)}
                                        disabled={total <= query.limit}

                                    >
                                        {'>'}
                                    </button>
                                </div>

                                <div className=' float-end col-lg-4 col-12'>

                                    <input
                                        type='text'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        value={searchInput}
                                        onChange={(ev) => setSearchInput(ev.target.value)}
                                    />

                                </div>

                            </div>

                            <div className='col-12'>
                                <Table responsive striped hover style={{ minWidth: 1200 }} className='max600'>
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th></th>
                                            <th onClick={() => handleSort('tipoAtencion')} >
                                                Tipo Atención
                                                {query.sortBy === 'tipoAtencion' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'tipoAtencion' && query.sortDir === 'desc' && '▼'}
                                            </th>
                                            <th >Complemento</th>
                                            <th >Imagen</th>
                                            <th >Color</th>
                                            <th >Ident.</th>
                                            <th >Sigla</th>
                                            <th onClick={() => handleSort('orden')}>
                                                Orden
                                                {query.sortBy === 'orden' && query.sortDir === 'asc' && '▲'}
                                                {query.sortBy === 'orden' && query.sortDir === 'desc' && '▼'}
                                            </th>
                                            <th >ind Prioridad</th>
                                            <th >Atn. Prioritaria</th>
                                            <th >Atn. Corriente</th>
                                            <th >Consec.</th>
                                            <th >Permite traslado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length === 0 ? (
                                            <tr>
                                                <td colSpan={15} className="text-center">
                                                    No hay registros
                                                </td>
                                            </tr>
                                        ) : (
                                            data.map((item) => (
                                                <tr key={item.uidTipoAtencion}>
                                                    <td>
                                                        {item.indActivo === 1 ? (
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() =>
                                                                    inactivaTipoAtencion(item.uidTipoAtencion, 0)
                                                                }
                                                            >
                                                                <i className="fa-solid fa-minus" ></i>
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className="btn btn-sm btn-success"
                                                                onClick={() =>
                                                                    inactivaTipoAtencion(item.uidTipoAtencion, 1)
                                                                }
                                                            >
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        )}
                                                        <button
                                                            className="btn btn-primary btn-sm m-1"
                                                            onClick={() => abrirEditar(item)}
                                                        >
                                                            <i className="fa-solid fa-pen"> </i>
                                                        </button>

                                                    </td>

                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-warning"
                                                            onClick={() =>
                                                                handleOpenHorarios(
                                                                    item.uidTipoAtencion,
                                                                    item.tipoAtencion
                                                                )
                                                            }
                                                        >
                                                            ⏰
                                                        </button>
                                                    </td>

                                                    <td>{item.tipoAtencion}</td>

                                                    <td>{item.complemento}</td>

                                                    <td>
                                                        <i className={item.icono}></i>
                                                    </td>

                                                    <td>
                                                        <div
                                                            style={{
                                                                width: 30,
                                                                height: 30,
                                                                borderRadius: 6,
                                                                backgroundColor: item.color || "#000000",
                                                                border: "1px solid #ccc"
                                                            }}
                                                        />
                                                    </td>

                                                    <td>{item.codigoTipoAtencion}</td>

                                                    <td>{item.sigla}</td>

                                                    <td>{item.orden}</td>

                                                    <td>
                                                        {item.indPrioridad === 1 ? (
                                                            <span className="badge bg-success">
                                                                Sí
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">
                                                                No
                                                            </span>
                                                        )}
                                                    </td>

                                                    <td>{item.prioritario}</td>

                                                    <td>{item.cantidad}</td>

                                                    <td>{item.consecutivo}</td>

                                                    <td>
                                                        {item.permiteTraslado === 1 ? (
                                                            <span className="badge bg-success">
                                                                Sí
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">
                                                                No
                                                            </span>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            <div className='pagination'>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page - 1)}
                                    disabled={query.page === 1}
                                >
                                    {'<'}
                                </button>
                                <button
                                    className='btn btn-sm btn-secondary m-1'
                                    onClick={() => paginate(query.page + 1)}
                                    disabled={total <= query.limit}
                                >
                                    {'>'}
                                </button>
                                <span className='m-2' >{totalPages === 0 ? 0 : query.page} / {totalPages}</span>
                            </div>

                        </div>
                    </div>

                </div>

                <TiposAtenHorarios
                    show={showHorarios}
                    onClose={() => setShowHorarios(false)}
                    tipoAtencion={selectedTipo}
                    horarios={horarios}
                    onAdd={handleAddHorario}
                    onEdit={handleEditHorario}
                    onDelete={handleDeleteHorario}
                />
                <CrearTipoAtencionModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    iconos={iconos}
                    ubicaciones={ubicaciones}
                    onSave={(datos) => registraTipoAtencion(datos)}
                    modo="crear"

                />
                <CrearTipoAtencionModal
                    show={showModalEditar}
                    onClose={() => setShowModalEditar(false)}
                    onSave={guardarEdicion}
                    iconos={iconos}
                    ubicaciones={ubicaciones}
                    initialData={tipoEditar}
                    modo="editar"
                />
            </>
        )
    }
}
